<template>
  <form data-vv-scope="CalendarEvent">
    <!-- {{startDate}} -->

    <!--
    <pre>{{ clientList }}</pre> -->
    <!-- <pre> {{ editingObject }}</pre> -->
    <vs-input
      id="addTitle"
      class="w-full mb-2"
      placeholder="Add Title"
      v-model="title"
      v-validate="'required'"
      data-vv-name="title"
      autofocus
    />
    <div
      v-if="errors.has('CalendarEvent.title')"
      style="color: red"
      class="invalid-feedback"
    >
      {{ errors.first("CalendarEvent.title") }}
    </div>

    <vs-checkbox v-model="all_day_event" class="my-2"
      >All Day Event</vs-checkbox
    >

    <!-- Radio Button For Selecting Types -->
    <!-- {{editingObject}} -->
    <div v-if="!editingObject">
      <div class="flex flex-wrap my-4">
        <label class="w-full">Scheduling Type</label>

        <vs-radio
          v-model="recurring_type"
          vs-name="radios1"
          vs-value="1"
          class="my-2 mr-2"
          >Daily</vs-radio
        >
        <vs-radio
          v-model="recurring_type"
          vs-name="radios1"
          vs-value="2"
          class="my-2 mr-2"
          >Weekly</vs-radio
        >
        <vs-radio
          v-model="recurring_type"
          vs-name="radios1"
          vs-value="4"
          class="my-2 mr-2"
          >Monthly</vs-radio
        >
      </div>
      <div v-if="recurring_type == 2">
        <v-select
          class="w-full my-2"
          multiple
          :options="weekOption"
          v-model="schedule_frequency_week_day"
          label="name"
          :reduce="item => item.value"
          v-validate="'required'"
          placeholder="WeekDays"
          data-vv-name="weekDay"
        >
        </v-select>
        <div
          v-if="errors.has('CalendarEvent.weekDay')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.weekDay") }}
        </div>
      </div>
      <div>
        <v-select
          class="w-full my-2"
          multiple
          v-if="recurring_type == 4"
          :options="monthDay"
          v-model="schedule_frequency_month_day"
          v-validate="'required'"
          placeholder="Monthday"
          data-vv-name="monthday"
        >
        </v-select>
        <div
          v-if="errors.has('CalendarEvent.monthday')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.monthday") }}
        </div>
      </div>
    </div>

    <div class="flex flex-wrap -mx-2">
      <div class="sm:w-1/2 w-full px-2 mb-2">
        <div class="cstm-flat-pickr-holder">
          <flat-pickr
            :config="configdateTimePickerTest"
            label="Time"
            class="w-full"
            v-model="schedule_start_date"
            placeholder="Schedule Start Date"
            data-vv-name="schedule start date"
            v-validate="'required'"
          />
          <span class="material-icons" data-toggle>calendar_today</span>
        </div>
        <div
          v-if="errors.has('CalendarEvent.schedule start date')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.schedule start date") }}
        </div>
      </div>
      <div class="sm:w-1/2 w-full px-2 mb-2" v-show="!all_day_event">
        <div class="cstm-flat-pickr-holder">
          <flat-pickr
            v-if="!all_day_event"
            :config="configTime"
            label="Time"
            class="w-full"
            v-model="schedule_from_time"
            placeholder="Select Time"
            v-validate="'required'"
            data-vv-name="schedule start time"
          />
          <span class="material-icons" data-toggle>arrow_drop_down</span>
        </div>
        <div
          v-if="errors.has('CalendarEvent.schedule start time')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.schedule start time") }}
        </div>
      </div>
      <div class="sm:w-1/2 w-full px-2 mb-2" v-if="!editingObject">
        <!-- {{event.course_start_time}} -->
        <div class="cstm-flat-pickr-holder">
          <flat-pickr
            :config="configdateTimePickerTest"
            label="Time"
            class="w-full"
            data-vv-name="schedule end date"
            v-model="schedule_end_date"
            placeholder="Schedule End Date"
            v-validate="'required'"
          />
          <span class="material-icons" data-toggle>calendar_today</span>
        </div>
        <div
          v-if="errors.has('CalendarEvent.schedule end date')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.schedule end date") }}
        </div>
      </div>
      <div class="sm:w-1/2 w-full px-2 mb-2" v-show="!all_day_event">
        <div class="cstm-flat-pickr-holder">
          <flat-pickr
            v-if="!all_day_event"
            :config="configTime"
            label="Time"
            class="w-full"
            v-model="schedule_to_time"
            placeholder="Select Time"
            v-validate="'required'"
            data-vv-name="schedule end time"
          />
          <span class="material-icons" data-toggle>arrow_drop_down</span>
        </div>
        <div
          v-if="errors.has('CalendarEvent.schedule end time')"
          style="color: red"
          class="invalid-feedback"
        >
          {{ errors.first("CalendarEvent.schedule end time") }}
        </div>
      </div>
    </div>
    <vs-textarea
      class="w-full mb-2"
      placeholder="Location"
      v-model="location"
      v-validate="'required'"
      data-vv-name="Location"
    ></vs-textarea>
    <div
      v-if="errors.has('CalendarEvent.Location')"
      style="color: red"
      class="invalid-feedback"
    >
      {{ errors.first("CalendarEvent.Location") }}
    </div>
    <!-- <input
    v-model="event.eventTextColor"
      class="w-full mb-2"
      type="color"
    /> -->
    <div class="cstmColorHolder">
      <div
        class="cstmColorDiv"
        @click="selectColor(index)"
        :class="{ active: activeIndex === index }"
        :style="{ backgroundColor: presetColor }"
        v-for="(presetColor, index) in presetColors"
        :key="index"
      ></div>
      <div class="moreColor">
        <input
          v-model="colour_code"
          type="color"
          v-validate="'required'"
          data-vv-name="textColor"
        />
        <a>More Colors</a>
      </div>
      <div
        v-if="errors.has('CalendarEvent.textColor')"
        style="color: red"
        class="invalid-feedback"
      >
        {{ errors.first("CalendarEvent.textColor") }}
      </div>
    </div>
    <content-component
      v-model="description"
      label="Add Description"
      :file_repository_id="repository_id"
    ></content-component>
    <label class="w-full">Staffs</label>
    <v-select
      :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
      class="w-full"
      multiple
      :options="userList"
      label="fullName"
      @open="onOpenTeacher"
      @close="onCloseTeacher"
      v-model="attachUserList"
    >
    <template v-slot:selected-option="userList">
      <img
        v-if="userList.picture"
        class="person-img rounded-full"
        :src="userList.picture"
      />
      <img
        v-else
        class="person-img rounded-full"
        src="@/assets/images/pages/user-circle-solid.svg"
      />
      {{ userList.first_name }}
      {{ userList.last_name }}
    </template>
    <template v-slot:option="userList">
      <img
        v-if="userList.picture"
        class="person-img rounded-full"
        :src="userList.picture"
      />
      <img
        v-else
        class="person-img rounded-full"
        src="@/assets/images/pages/user-circle-solid.svg"
      />
      {{ userList.first_name }}
      {{ userList.last_name }}
    </template>
    <template #list-footer>
      <li
        ref="loadTeacher"
        class="loader"
        v-show="userListMeta.has_next"
      >
        Loading more staffs...
      </li>
    </template>
    </v-select>

    <label class="w-full">Students</label>
    <v-select
      :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
      class="w-full"
      multiple
      :options="clientList"
      label="fullName"
      v-model="attachCLientList"
      @open="onOpenStudent"
      @close="onCloseStudent"
    >
    <template v-slot:selected-option="clientList">
      <img
        v-if="clientList.picture"
        class="person-img rounded-full"
        :src="clientList.picture"
      />
      <img
        v-else
        class="person-img rounded-full"
        src="@/assets/images/pages/user-circle-solid.svg"
      />
      {{ clientList.first_name }}
        {{ clientList.last_name }}
      </template>
    <template v-slot:option="clientList">
      <img
        v-if="clientList.picture"
        class="person-img rounded-full"
        :src="clientList.picture"
      />
      <img
        v-else
        class="person-img rounded-full"
        src="@/assets/images/pages/user-circle-solid.svg"
      />
      {{ clientList.first_name }}
      {{ clientList.last_name }}
    </template>
    <template #list-footer>
      <li
        ref="loadStudent"
        class="loader"
        v-show="clientListMeta.has_next"
      >
        Loading more students...
      </li>
    </template>
    </v-select>
    <div class="mt-4 text-right">
      <vs-button type="border" @click="cancelEvent">Cancel</vs-button>
      <vs-button class="ml-2" @click="saveEvent()" v-if="!editingObject"
        >Save</vs-button
      >
      <vs-button class="ml-2" @click="updateEvent()" v-else>Update</vs-button>
    </div>
  </form>
</template>
<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import ContentComponent from '@/components/tinyEditor/ContentComponent.vue'
import vSelect from 'vue-select'
import {
  CreateGeneralEventApi,
  UpdateGeneralEventApi
} from '@/api/schedulerApi'
import { UserMixins } from '@/mixins/UserMixins'
import { eventMixin } from '../mixins/eventMixin'
import { repository } from '@/mixins/repository.js'

export default {
  components: {
    flatPickr,
    ContentComponent,
    vSelect
  },
  props: {
    startDate: {},
    endDate: {},
    editingObject: {
      type: Object,
      default: null
    }
  },
  mixins: [UserMixins, eventMixin, repository],
  data () {
    return {
      observerUser: new IntersectionObserver(this.loadMoreUser),
      observerStudent: new IntersectionObserver(this.loadMoreClient),
      clientListMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      userListMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      observerTeacher: new IntersectionObserver(this.loadMoreStaff),
      observerStudent: new IntersectionObserver(this.loadMoreStudent),
      attachUserList: [],
      attachCLientList: [],
      weekOption: [
        {
          name: 'Sunday',
          value: 'Sun'
        },
        {
          name: 'Monday',
          value: 'Mon'
        },
        {
          name: 'Tuesday',
          value: 'Tue'
        },
        {
          name: 'Wednesday',
          value: 'Wed'
        },
        {
          name: 'Thursday',
          value: 'Thu'
        },
        {
          name: 'Friday',
          value: 'Fri'
        },
        {
          name: 'Saturday',
          value: 'Sat'
        }
      ],

      monthDay: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31
      ],
      id: null,
      title: '',
      schedule_start_date: new Date().toISOString().slice(0, 10),
      schedule_end_date: new Date().toISOString().slice(0, 10),
      location: null,
      description: null,
      schedule_from_time: null,
      schedule_to_time: null,
      eventTypePicked: null,
      colour_code: '#d50000',
      schedule_frequency_week_day: [],
      schedule_frequency_month_day: [],
      recurring_type: 1,
      all_day_event: false,
      presetColors: [
        '#d50000',
        '#f4511e',
        '#e67c73',
        '#f6bf26',
        '#3f51b5',
        '#0b8043',
        '#039be5',
        '#33b679',
        '#7986cb',
        '#8e24aa',
        '#616161',
        '#b39ddb',
        '#e737e5',
        '#70d7dc'
      ],
      activeIndex: undefined,

      configdateTimePickerTest: {
        altInput: true,
        altFormat: 'j F, Y',
        // dateFormat: 'Y-m-d',
        wrap: true,
        dateFormat: 'Y-m-d',
        minDate: new Date()
      },
      configTime: {
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        enableSeconds: true,
        dateFormat: 'H:i:S',
        wrap: true
      }
    }
  },
  created () {
    this.getRepositoryId(null)
    this.schedule_start_date = new Date(this.startDate)
      .toISOString()
      .slice(0, 10)
    this.schedule_end_date = new Date(this.startDate)
      .toISOString()
      .slice(0, 10)
    const user = this.loadUserClientList('User', this.userListMeta)
    const client = this.loadUserClientList('Client', this.clientListMeta)
    Promise.all([user, client]).then(value => {
      if (!value.includes(false)) {
        if (this.editingObject) {
          this.title = this.editingObject.title
          this.schedule_start_date = new Date(this.editingObject.schedule_date)
          this.schedule_from_time = this.editingObject.schedule_from_time
          this.schedule_to_time = this.editingObject.schedule_to_time
          this.location = this.editingObject.location
          this.colour_code = this.editingObject.colour_code
          this.description = this.editingObject.description
          this.all_day_event = this.editingObject.all_day_event
          
          this.attachUserList = this.editingObject.user_participants.map( (ele) => {
            return {
              first_name: ele.user.first_name,
              last_name: ele.user.last_name,
              user_id: ele.user_id,
              user_type: 1,
              picture: ele.picture
            }
          })

          this.attachCLientList = this.editingObject.client_participants.map( (ele) => {
            return {
              first_name: ele.client_user.first_name,
              last_name: ele.client_user.last_name,
              client_user_id: ele.client_user_id,
              user_type: 2,
              picture: ele.picture
            }
          })

          this.activeIndex = this.presetColors.findIndex((colorCode) => colorCode === this.colour_code)
        }
      }
    })

    //
  },
  /* beforeDestroy () {
    this.editingObject = null
  },
   */
  mounted () {
    /* this.event.course_start = this.startDate
    this.event.course_end = this.endDate */
    setTimeout(() => {
      // console.log(document.querySelector('#addTitle'))
      document.querySelector('#addTitle').focus()
    }, 0)
  },
  methods: {
    async onOpenTeacher () {
      if (this.userListMeta.has_next) {
        await this.$nextTick()
        this.observerTeacher.observe(this.$refs.loadTeacher)
      }
    },
    onCloseTeacher () {
      this.observerTeacher.disconnect()
    },
    async loadMoreStaff () {
      try {
        this.userListMeta.current_page = this.userListMeta.current_page + 1
        this.loadUserClientList('User', this.userListMeta)
      } catch (e) {
        //
      }
    },
    async onOpenStudent () {
      if (this.clientListMeta.has_next) {
        await this.$nextTick()
        this.observerStudent.observe(this.$refs.loadStudent)
      }
    },
    onCloseStudent () {
      this.observerStudent.disconnect()
    },
    async loadMoreStudent () {
      try {
        this.clientListMeta.current_page = this.clientListMeta.current_page + 1
        this.loadUserClientList('Client', this.clientListMeta)
      } catch (e) {
        //
      }
    },
    cancelEvent () {
      this.$emit('cancelEventEmit')
    },
    saveEvent () {
      this.$validator.validateAll('CalendarEvent').then(valid => {
        if (valid) {
          const payload = {
            all_day_event: this.all_day_event,
            title: this.title,
            schedule_start_date: this.schedule_start_date,
            schedule_end_date: this.schedule_end_date,
            location: this.location,
            description: this.description,
            schedule_from_time: this.schedule_from_time,
            schedule_to_time: this.schedule_to_time,
            colour_code: this.colour_code,
            schedule_frequency_week_day: this.schedule_frequency_week_day,
            schedule_frequency_month_day: this.schedule_frequency_month_day,
            recurring_type: this.recurring_type,
            participants: [...this.attachUserList, ...this.attachCLientList],
            custom: 1
          }
          if (!this.all_day_event) {
            if (
              this.schedule_from_time === null ||
              this.schedule_from_time === null
            ) {
              const message = 'Time is required'
              this.showSuccessMessage('Error', `${message}`, 'danger')
            }
          }

          const checkingDateToday = this.validateTodayDate(
            new Date(),
            new Date(this.schedule_start_date)
          )
          const hasCheckingStartEndDate = this.validateTodayDate(
            new Date(this.schedule_start_date),
            new Date(this.schedule_end_date)
          )

          if (checkingDateToday <= 0 && hasCheckingStartEndDate <= 0) {
            this.savingEvent(payload)
          } else {
            let message = ''

            if (checkingDateToday > 0) {
              message = 'Event can not be scheduled on a past date'
            } else if (hasCheckingStartEndDate > 0) {
              message = 'Start date must be less than end date'
            }
            this.showSuccessMessage('Error', `${message}`, 'danger')
          }
        } else {
          this.showSuccessMessage('Error', 'Validation is Required', 'danger')
        }
      })
    },
    updateEvent () {
      const payload = {
        id: this.editingObject.id,
        all_day_event: this.all_day_event,
        title: this.title,
        schedule_date: this.schedule_start_date,
        location: this.location,
        description: this.description,
        schedule_from_time: this.schedule_from_time,
        schedule_to_time: this.schedule_to_time,
        colour_code: this.colour_code,
        participants: [...this.attachUserList, ...this.attachCLientList],
        custom: 1
      }

      this.$validator.validateAll('CalendarEvent').then(res => {
        this.updatingEvent(payload)
      })

      // this.$emit('createEvent', this.event)
    },

    async updatingEvent (payload) {
      try {
        const customer_id = this.$store.getters.customerId

        const data = await UpdateGeneralEventApi(payload, customer_id)
        this.$emit('saveEventEmit', 'Updated')
      } catch (error) {}
    },
    async savingEvent (payload) {
      try {
        const customer_id = this.$store.getters.customerId

        const data = await CreateGeneralEventApi(payload, customer_id)
        this.$emit('saveEventEmit', 'added')
      } catch (error) {}
    },
    selectColor (index) {
      // alert(this.presetColors[index])
      this.colour_code = this.presetColors[index]
      this.activeIndex = index
      // alert(this.eventTextColor)
    }
  }
}
</script>

<style>
.cstm-flat-pickr-holder {
  position: relative;
}
.cstm-flat-pickr-holder .material-icons {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 5px;
  cursor: pointer;
}
</style>
